import { useIntl } from 'react-intl';

import { useFeatureFlags } from 'common/hooks';
import useUser from 'common/hooks/useUser';

type UseBestOfWoltFeatureFlagProps = {
  venueId: string;
  venueCountry: Country;
  venueCity: string;
  enabled?: boolean;
};
const useBestOfWoltFeatureFlag = ({
  venueId,
  venueCountry,
  venueCity,
  enabled = true,
}: UseBestOfWoltFeatureFlagProps) => {
  const featureFlagName = 'merchant_best_of_wolt';
  const { user, isEmployee } = useUser();
  const { locale } = useIntl();

  const { data: featureFlags, isLoading } = useFeatureFlags(
    [featureFlagName],
    {
      user_email: user?.email || '',
      user_country: user?.country || '',
      is_employee: isEmployee,
      entity_id: venueId,
      entity_country: venueCountry,
      entity_city: venueCity,
      locale,
    },
    { enabled },
  );

  return { isLoading, isBestOfWoltEnabled: featureFlags?.[featureFlagName] === 'on' };
};

export default useBestOfWoltFeatureFlag;
